__webpack_require__.p = "/syma-afsha/";